/**
 * The help assistant's opening message. Single source of truth on the
 * dashboard: it renders as the first chat bubble (ChatThread) AND is previewed,
 * truncated, in the post-onboarding nudge card (FeedbackFab) — so the card
 * literally previews the chat's first message. Byte-for-byte mirror of the
 * extension greeting (packages/extension/src/content/help/greeting.ts:9); keep
 * the two in sync. Emojis are allowed here: this is conversational message
 * copy, not UI chrome.
 */
export const HELP_GREETING =
  "Hey! 👋 Want to know how to export, run into any issues, or do you have feedback? Let us know how we can help.";
